import { ProFormTimePicker as OriginalProFormTimePicker } from '@ant-design/pro-components';
import { withWrap } from '../../utils/hoc';
const ProFormTimePicker = withWrap(OriginalProFormTimePicker);
ProFormTimePicker.RangePicker = withWrap(OriginalProFormTimePicker.RangePicker);
export default ProFormTimePicker;
